export default __webpack_public_path__ + "static/media/help10.3222f19b.svg";